exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* UU5.Forms.Text */\n.uu5-forms-select {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-select:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n.uu5-forms-select-open .uu5-forms-items-input {\n  z-index: 10;\n}\n.uu5-forms-select-link {\n  width: 100%;\n  position: relative;\n  height: 2.4em;\n  padding: 0.6em;\n  display: block;\n}\n.uu5-forms-select-link,\n.uu5-forms-select-link:hover {\n  text-decoration: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/select.less
// module id = 330
// module chunks = 0